/**
 * Parse Capacitor / custom-scheme / https deep links into an in-app path.
 *
 * Supported examples:
 *   oola://login-v2
 *   oola://dashboard-v2
 *   oola:///Usana/UsanaLogin/<token>
 *   https://dashboard.oolalife.com/login-v2
 *   https://dashboard.oolalife.com/Usana/UsanaLogin/<token>
 */
export function pathFromAppUrl(rawUrl) {
    if (!rawUrl || typeof rawUrl !== 'string') return null;

    try {
        const url = new URL(rawUrl);

        if (url.protocol === 'oola:') {
            // oola://login-v2  → host=login-v2, pathname=/
            // oola:///login-v2 → host='', pathname=/login-v2
            const hostPart = url.hostname ? `/${url.hostname}` : '';
            const pathPart = url.pathname === '/' ? '' : url.pathname;
            let path = `${hostPart}${pathPart}` || '/';
            if (!path.startsWith('/')) path = `/${path}`;
            if (url.search) path += url.search;
            if (url.hash) path += url.hash;
            return path === '//' ? '/' : path.replace(/\/{2,}/g, '/');
        }

        if (url.protocol === 'http:' || url.protocol === 'https:') {
            return `${url.pathname || '/'}${url.search || ''}${url.hash || ''}`;
        }
    } catch {
        return null;
    }

    return null;
}

/**
 * First paint on a cold native start: Portal V2 login.
 * Lite app mode still starts at login-v2; post-login goes to dashboard (see LoginV2).
 */
export function nativeColdStartPath(currentPathname) {
    const path = currentPathname || '/';
    if (path === '/' || path === '/index.html' || path === '/login') {
        return '/login-v2';
    }
    return null;
}
